import React from "react";

import i18n from "i18n-react";

import { HashLink as Link } from "react-router-hash-link";

const TermsAndConditionsView = () => {
  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get("mobile")) {
    mobile = true;
  }

  let email = "";
  if (params.get("email")) {
    email = params.get("email");
  }

  return (
    <div className="contentContainer BookingForm">
      <div className="header">
        <h3>{i18n.translate("rewards.TermsAndConditions.title")}</h3>
      </div>
      <div className="bodyRewardsTerms">
        <p>
          {i18n.translate("rewards.TermsAndConditions.body1")}
          <br />
          <br />
          {i18n.translate("rewards.TermsAndConditions.body2")}
          <br />
          <br />
          {i18n.translate("rewards.TermsAndConditions.body3")}
          <br />
          <br />
          <span>{i18n.translate("rewards.TermsAndConditions.body4")}</span>
          <br />
          {i18n.translate("rewards.TermsAndConditions.body5")}
          <br />
          <br />
        </p>

        <hr />

        <div className="buttonHolder">
          {mobile && (
            <Link to={`/main/rewards?mobile=true&email=${email}`}>
              <button className="btn">
                {i18n.translate("rewards.TermsAndConditions.button")} &gt;
              </button>
            </Link>
          )}
          {!mobile && (
            <Link to="/main/rewards">
              <button className="btn">
                {i18n.translate("rewards.TermsAndConditions.button")} &gt;
              </button>
            </Link>
          )}
        </div>
      </div>
      {mobile && (
        <style>
          {
            "\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }"
          }
        </style>
      )}
    </div>
  );
};

export default TermsAndConditionsView;
